<template>
  <div class="main">
    <c-panel title="Veículo" titleIcon="fas fa-bus">
      <form-veiculo :paramId="id" @onSubmitVeiculo="afterSubmit"></form-veiculo>
    </c-panel>
  </div>
</template>

<script>
import formVeiculo from "./form"

export default {
  components: { formVeiculo },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/veiculo') }
  }
}
</script>

